export default {
  settingAssignGoods: {
    // code: '商品编码',

    table: {
      // name: '商品名称',
      price: '指定物流',
      business: '指定物流业务',
      updater: '更新人',
      lastUpdater: '最近更新时间'
    },

    addAndEdit: {
      editCommodity: '编辑指定商品配置',
      addCommodity: '新建指定商品配置',
      business: '指定业务',
      codePlaceholder: '请选择商品',
      selectCommodity: '选择商品',
      logisticsText: '请先选择所属物流商',
      logisticsRules: '请选择指定物流',
      businessRules: '请选择指定业务'

    }
  }
};
